<template>
  <div class="beforeclass-wrapper">
    <p class="title">课前必做</p>
    <p class="info">完成所有的班级事务之后，才能正常上课</p>
    <div class="detail" v-if="data.class_notice">
      <p><img src="../../../static/images/beforeclass.png">课前须知</p>
      <span class="unaccomplished" @click="tofinish(1)" v-if="data.class_notice == 1">去查看</span>
      <span class="finished" v-else-if="data.class_notice == 2"><img src="../../../static/images/follow.png">已查看</span>
    </div>
    <div class="detail" v-if="data.class_assistance">
      <p><img src="../../../static/images/assistant.png">关注微信学习助手</p>
      <span class="unaccomplished" @click="isshow = true" v-if="data.class_assistance == 1">去关注</span>
      <span class="finished" v-else-if="data.class_assistance == 2"><img
        src="../../../static/images/follow.png">已关注</span>
    </div>
    <div class="detail" v-if="data.class_handout">
      <p><img src="../../../static/images/book.png">教辅配送</p>
      <span class="unaccomplished" @click="tofinish(2, data.code, data.mail_system_sn)" v-if="data.class_handout == 1">去申请</span>
      <span class="finished" v-else-if="data.class_handout == 2"><img src="../../../static/images/follow.png">已申请</span>
    </div>
    <div class="detail" v-if="data.class_agreement">
      <p><img src="../../../static/images/agreements.png">协议与凭证</p>
      <span class="unaccomplished" @click="tofinish(3)" v-if="data.class_agreement == 1">去签订</span>
      <span class="finished" v-else-if="data.class_agreement == 2"><img
        src="../../../static/images/follow.png">已签订</span>
    </div>
    <div class="detail" v-if="data.class_archives">
      <p><img src="../../../static/images/archives.png">学员档案</p>
      <span class="unaccomplished" @click="tofinish" v-if="data.class_archives == 1">去完善</span>
      <span class="finished" v-else-if="data.class_archives == 2"><img
        src="../../../static/images/follow.png">已完善</span>
    </div>
    <div class="detail" v-if="data.class_attend_class">
      <p><img src="../../../static/images/self.png">自助开课</p>
      <span class="unaccomplished" @click="tofinish" v-if="data.class_attend_class == 1">去开课</span>
      <span class="finished" v-else-if="data.class_attend_class == 2"><img
        src="../../../static/images/follow.png">已开课</span>
    </div>
    <div class="mask" v-if="isshow">
      <div class="box">
        <p class="tit">{{data.assistance_name}}</p>
        <p class="subtitle">关注公众号，绑定开课手机号<br/>即可获取直播提醒和更多学习服务</p>
        <img class="qrcode" :src="data.assistance_url">
        <p class="tip">长按保存二维码，打开微信扫一扫</p>
        <p class="copy_title">复制公众号去关注<img class="copy" @click="copy_text" src="../../../static/images/copy.png"><input
          class="learn_text" type="text" :value="data.assistance_name"></p>
        <img class="close" @click="isshow = false" src="../../../static/images/shut.png">
      </div>
    </div>
    <div class="mask" v-if="flag">
      <div class="wrapper">
        <div class="content">
          <img src="../../../static/images/shut_off.png" @click="close">
          <p class="class_notice_title">课前须知</p>
          <div class="class_notice_text" v-html="data.class_notice_text.replace(/\n/g, '<br/>')"></div>
        </div>
        <p class="read_close" :class="[count > 0 ? 'disabled' : '']" @click="record">我知道了<span v-if="count">（<span
          class="countdown">{{count}}S</span>）</span></p>
      </div>
    </div>
  </div>
</template>
<script>
  import {Toast} from 'vant'

  export default {
    data () {
      return {
        data: [],
        flag: false,
        isshow: false,
        url: '',
        count: 3,
        timer: null
      }
    },
    mounted () {
      this.getstatus()
      this.getagreement()
    },
    methods: {
      getstatus () {
        this.$api.COMPULSORY({
          business_id: this.$route.query.business_id,
          'offcn-ticket': this.$route.query.ticket,
          is_h5: 1
        }).then((res) => {
          if (res.code == 0) {
            this.data = res.data
          } else if (res.code == 2 || res.code == 4) {
            sso.ready().then(function (user) {
              user.logout()
            })
          }
        })
      },
      getagreement () {
        this.$api.AGREEMENT({
          'offcn-ticket': this.$route.query.ticket
        }).then((res) => {
          if (res.code == 0) {
            this.url = res.data.url
          } else if (res.code == 2 || res.code == 4) {
            sso.ready().then(function (user) {
              user.logout()
            })
          }
        })
      },
      tofinish (type, code, sn) {
        if (type == 1) {
          this.flag = true
          this.count = 3
          let that = this
          this.timer = setInterval(function () {
            if (that.count < 1) {
              clearInterval(that.timer)
            } else {
              that.count--
            }
          }, 1000)
        } else if (type == 2) {
          if (window.location.host == 'xue.eoffcn.com') {
            location.href = 'https://erp.eoffcn.com/h5/web/h5_order.html?userId=' + JSON.parse(localStorage.getItem('ticketObj')).sso_id + '&auth-code=' + code + '&studyPlatform=1&auth-code=' + '&systemSNMany=' + sn
          } else {
            location.href = 'https://erp.t.eoffcn.com/h5/web/h5_order.html?userId=' + JSON.parse(localStorage.getItem('ticketObj')).sso_id + '&auth-code=' + code + '&studyPlatform=1&auth-code=' + '&systemSNMany=' + sn
          }
        } else if (type == 3) {
          console.log(this.url)
          location.href = this.url
        } else {
          Toast('去APP使用')
        }
      },
      copy_text () {
        var copytext = $('.learn_text')
        console.log(copytext.select()) // 选择对象
        document.execCommand('Copy') // 执行浏览器复制命令
        Toast('复制成功')
      },
      close () {
        this.flag = false
        clearInterval(this.timer)
      },
      record () {
        if (this.count == 0) {
          this.flag = false
          this.$api.ADDSTUNOTICE({
            business_id: this.$route.query.business_id,
            'offcn-ticket': this.$route.query.ticket
          }).then((res) => {
            if (res.code == 0) {
              console.log(11111)
            } else if (res.code == 2 || res.code == 4) {
              sso.ready().then(function (user) {
                user.logout()
              })
            }
          })
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .beforeclass-wrapper {
    margin: 50px 30px;
    .title {
      text-align: center;
      font-size: 34px;
      font-weight: bold;
    }
    .info {
      text-align: center;
      font-size: 26px;
      color: #666666;
      margin-top: 14px;
      margin-bottom: 40px;
    }
    .detail {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 30px;
      font-weight: bold;
      background: #ffffff;
      border-radius: 10px;
      padding: 30px;
      margin-top: 20px;
      box-shadow: 0px 0px 18px 0px rgba(224, 224, 224, 0.8);
      p {
        display: flex;
        align-items: center;
      }
      img {
        width: 56px;
        height: 56px;
        margin-right: 20px;
      }
      .unaccomplished {
        width: 100px;
        height: 44px;
        text-align: center;
        line-height: 44px;
        font-size: 20px;
        font-weight: normal;
        color: #e60012;
        border: 1px solid #e60012;
        border-radius: 22px;
      }
      .finished {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: normal;
        img {
          width: 25px;
          height: 25px;
        }
      }
    }
    .tit {
      font-size: 36px;
    }
    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      .box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 500px;
        text-align: center;
        color: #333333;
        font-weight: bold;
        border-radius: 20px;
        background: #ffffff;
        padding: 40px 0;
        .subtitle {
          font-size: 24px;
          color: #666666;
          font-weight: normal;
          margin-top: 14px;
        }
        .qrcode {
          width: 400px;
          height: 400px;
          margin-top: 20px;
          border-radius: 20px;
        }
        .tip {
          font-size: 26px;
          color: #666666;
          font-weight: normal;
        }
        .copy_title {
          border-top: 1px solid #e5e5e5;
          font-size: 30px;
          margin-top: 30px;
          padding-top: 20px;
          .copy {
            width: 25px;
            height: 26px;
            margin-left: 10px;
          }
          .learn_text {
            position: absolute;
            opacity: 0;
          }
        }
        .close {
          position: absolute;
          width: 114px;
          height: 114px;
          bottom: -116px;
          left: 192px;
        }
      }
      .wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20px;
        background: #ffffff;
        .content {
          padding: 60px 48px;
          img {
            position: absolute;
            top: 30px;
            right: 30px;
            width: 32px;
            height: 32px
          }
          .class_notice_title {
            text-align: center;
            color: #333333;
            font-size: 32px;
            font-weight: bold;
          }
          .class_notice_text {
            width: 500px;
            height: 408px;
            overflow-y: scroll;
            font-size: 28px;
            margin-top: 20px;
          }
        }
        .read_close {
          height: 110px;
          text-align: center;
          line-height: 110px;
          color: #e60012;
          font-size: 32px;
          font-weight: bold;
          border-top: 1px solid #e5e5e5;
          .countdown {
            color: #e60012;
          }
        }
        .disabled {
          color: #999999;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/beforeClass/index.vue